import { store } from '@/vuex/store'
import { logger } from '@/plugins/logger'

export function getAuthToken () {
  return store.getters['auth/authToken']
}

export async function authedMiddleware (to, from, next) {
  //Todo: write a better Auth and User plugin
  store.commit('setLoading', true)
  logger.info('authed-middleware-start', {
    path: to.fullPath,
    companyId: to.params.company_id,
  })
  try {
    let companyId = to.params.company_id
    if (companyId) {
      await store.dispatch('initialize', companyId)
      await store.dispatch('updateCompanyId', companyId)
    }
  } catch (e) {
    logger.error('authed-middleware-init-error', {
      message: e?.message || String(e),
      path: to.fullPath,
    })
    console.log('Company Init Error')
  }
  store.commit('setLoading', false)
  if (!store.getters['auth/isLoggedIn']) {
    logger.warn('authed-middleware-not-logged-in', {
      path: to.fullPath,
      hasToken: !!store.getters['auth/authToken'],
    })
    logger.flush()
    next({
      name: 'login',
      query: { redirect: to.fullPath, },
    })
  } else {
    logger.info('authed-middleware-complete', { path: to.fullPath, })
    next()
  }
}

export function redirectToDefaultRoute (to, from, next) {
  next(store.getters['auth/user/defaultRoute'])
}
